<template>
    <div class="comp-crs-info comp">
        <el-row v-if="showdata" class="taxes-box two-cols-form">
            <el-form
                ref="taxesInfo"
                :model="taxesInfo"
                :rules="rules"
                label-width="160px"
                class="acct-form"
                size="small"
                v-on:submit.native.prevent
            >
                <el-col :span="24" class="mes-col">
                    <el-col :span="12">
                        <el-form-item label="出生日期：" class="form-text">
                            <div class="text-con">
                                {{ $util.fmtDate(taxesInfo.investorsbirthday) }}
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="税收居民身份：" class="required" prop="taxestype">
                            <el-select
                                v-model="taxesInfo.taxestype"
                                filterable
                                placeholder="请选择税收居民身份"
                                :disabled="oldTax !== '' || isJustCheck"
                            >
                                <el-option
                                    v-for="item in taxestypes"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="taxe" :span="12">
                        <el-form-item
                            label="姓(英文或拼音)："
                            prop="custfirstname"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.custfirstname"
                                placeholder="请输入"
                                :maxlength="32"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col v-if="taxe" :span="12">
                        <el-form-item
                            label="名(英文或拼音)："
                            prop="custfamilyname"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.custfamilyname"
                                placeholder="请输入"
                                :maxlength="32"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="taxe" :span="24" class="mes-col">
                    <el-col :span="24">
                        <div class="line-container">
                            <div class="title-line"></div>
                            <span class="title-content">现居地</span>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="国家/地区：" prop="currentcountry" class="required">
                            <el-select
                                v-model="taxesInfo.currentcountry"
                                filterable
                                :filter-method="filterCountrys"
                                placeholder="请选择现居地国家"
                                :disabled="isJustCheck"
                                v-on:change="currentcountrySel"
                            >
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="nonMandatory" :span="12">
                        <el-form-item
                            v-if="isChina && taxesInfo.currentprovince"
                            label="省份："
                            prop="currentprovince"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.currentprovince"
                                filterable
                                placeholder="请选择现居地省份"
                                :disabled="isJustCheck"
                                v-on:change="currentprovinceSel"
                            >
                                <el-option
                                    v-for="item in provinces"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="nonMandatory" :span="12">
                        <el-form-item
                            v-if="isChina && taxesInfo.currentcity"
                            label="城市："
                            prop="currentcity"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.currentcity"
                                filterable
                                placeholder="请选择现居城市"
                                :disabled="isJustCheck"
                                v-on:change="currentcitySel"
                            >
                                <el-option
                                    v-for="item in currentcity"
                                    :key="item.cityid"
                                    :value="item.cityid"
                                    :label="item.cityname"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="nonMandatory" :span="12">
                        <el-form-item
                            v-if="isChina && taxesInfo.county"
                            label="区/县："
                            prop="county"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.county"
                                filterable
                                placeholder=""
                                :disabled="isJustCheck"
                            >
                                <el-option
                                    v-for="item in county"
                                    :key="item.countyid"
                                    :label="item.countyname"
                                    :value="item.countyid"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col v-if="nonMandatory" :span="12">
                        <el-form-item label="地址：" prop="address" :class="{ required: isChina }">
                            <el-input
                                v-model="taxesInfo.address"
                                placeholder="请输入现居地地址"
                                :maxlength="32"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <!-- <el-col v-if="nonMandatory" :span="12">
                        <el-form-item label="邮编：" prop="crspostcode" class="required">
                            <el-input
                                v-model="taxesInfo.crspostcode"
                                placeholder="请输入现居地邮编"
                                :maxlength="32"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col> -->
                </el-col>
                <el-col v-if="taxe" :span="24" class="mes-col">
                    <div class="line-container">
                        <div class="title-line"></div>
                        <span class="title-content">现居地(英文或拼音)</span>
                    </div>
                    <el-col :span="12">
                        <el-form-item label="国家/地区：" prop="engcurrentcountry" class="required">
                            <el-select
                                v-model="taxesInfo.engcurrentcountry"
                                filterable
                                :filter-method="filterEnCountrys"
                                placeholder="请选择现居地国家/地区(中文)"
                                :disabled="isJustCheck"
                            >
                                <el-option
                                    v-for="item in enCountrys"
                                    :key="item.subitem"
                                    :label="item.subitem + '(' + item.subitemname + ')'"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engcurrentcountry == 'CN'"
                            label="省份："
                            prop="engcurrentprovince"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engcurrentprovince"
                                placeholder="请输入现居地省份(英文或拼音)"
                                :maxlength="64"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engcurrentcountry == 'CN'"
                            label="城市："
                            prop="engcurrentcity"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engcurrentcity"
                                placeholder="请输入现居地城市(英文或拼音)"
                                :maxlength="64"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engcurrentcountry == 'CN'"
                            label="区/县:"
                            prop="engcurrentcounty"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engcurrentcounty"
                                :maxlength="64"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址：" prop="engaddress" class="required">
                            <el-input
                                v-model="taxesInfo.engaddress"
                                placeholder="请输入现居地地址(英文或拼音)"
                                :maxlength="64"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="taxe && nonMandatory" :span="24" class="mes-col">
                    <div class="line-container">
                        <div class="title-line"></div>
                        <span class="title-content">出生地</span>
                    </div>
                    <el-col :span="12">
                        <el-form-item label="国家/地区：" prop="birthcountry" class="required">
                            <el-select
                                v-model="taxesInfo.birthcountry"
                                :disabled="isJustCheck"
                                filterable
                                :filter-method="filterCountrys"
                                placeholder="请选择出生地国家/地区(中文)"
                                v-on:change="
                                    taxesInfo.birthprovince = '';
                                    taxesInfo.birthcity = '';
                                "
                            >
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.birthcountry === 'CN' && taxesInfo.birthprovince"
                            label="省份："
                            prop="birthprovince"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.birthprovince"
                                :disabled="isJustCheck"
                                filterable
                                placeholder="请选择出生地省份"
                                v-on:change="
                                    taxesInfo.birthcity = '';
                                    taxesInfo.birthprovince
                                        ? getCity(taxesInfo.birthprovince, 'birthcity')
                                        : '';
                                "
                            >
                                <el-option
                                    v-for="item in provinces"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.birthcountry === 'CN' && taxesInfo.birthcity"
                            label="城市："
                            prop="birthcity"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.birthcity"
                                :disabled="isJustCheck"
                                filterable
                                placeholder="请选择出生地城市"
                                v-on:change="currentcitySel"
                            >
                                <el-option
                                    v-for="item in birthcity"
                                    :key="item.cityid"
                                    :value="item.cityid"
                                    :label="item.cityname"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.birthcountry === 'CN' && taxesInfo.birthcounty"
                            label="区/县："
                            prop="birthcounty"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.birthcounty"
                                :disabled="isJustCheck"
                                filterable
                            >
                                <el-option
                                    v-for="item in county"
                                    :key="item.countyid"
                                    :label="item.countyname"
                                    :value="item.countyid"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址：" prop="birthplace">
                            <el-input
                                v-model="taxesInfo.birthplace"
                                placeholder="请输入出生地地址(中文)"
                                :maxlength="32"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="taxe" :span="24" class="mes-col bg">
                    <div class="line-container">
                        <div class="title-line"></div>
                        <span class="title-content">出生地(英文或拼音)</span>
                    </div>
                    <el-col :span="12">
                        <el-form-item label="国家/地区：" prop="engbirthcountry" class="required">
                            <el-select
                                v-model="taxesInfo.engbirthcountry"
                                :disabled="isJustCheck"
                                filterable
                                :filter-method="filterEnCountrys"
                                placeholder="请选择出生地国家/地区(英文或拼音)"
                            >
                                <el-option
                                    v-for="item in enCountrys"
                                    :key="item.subitem"
                                    :label="item.subitem + '(' + item.subitemname + ')'"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engbirthcountry == 'CN'"
                            label="省份："
                            prop="engbirthprovince"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engbirthprovince"
                                placeholder="请输入出生地省份(英文或拼音)"
                                :maxlength="64"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engbirthcountry == 'CN'"
                            label="城市："
                            prop="engbirthcity"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engbirthcity"
                                placeholder="请输入出生地城市(英文或拼音)"
                                :maxlength="64"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.engbirthcountry == 'CN'"
                            label="县区："
                            prop="engbirthcounty"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.engbirthcounty"
                                :maxlength="64"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址：" prop="engbirthplace" class="required">
                            <el-input
                                v-model="taxesInfo.engbirthplace"
                                placeholder="请输入出生地地址(英文或拼音)"
                                :maxlength="64"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="taxe" :span="24" class="mes-col last">
                    <div class="line-container">
                        <div class="title-line"></div>
                        <span class="title-content">税收居民国家/地区</span>
                    </div>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.regregioncode"
                            label="注册国家/地区："
                            prop="regregioncode"
                        >
                            <el-select
                                v-model="taxesInfo.regregioncode"
                                :disabled="isJustCheck"
                                filterable
                                :filter-method="filterCountrys"
                                placeholder="请选择注册国家"
                            >
                                <el-option
                                    v-for="item in countrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.regadress"
                            label="注册地址："
                            prop="regadress"
                        >
                            <el-input
                                v-model="taxesInfo.regadress"
                                placeholder="请输入注册地址"
                                :maxlength="32"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="税收居民国家/地区："
                            prop="taxesplace"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.taxesplace"
                                :disabled="!$util.isEmpty(taxId) || isJustCheck"
                                filterable
                                :filter-method="filterSpeCountrys"
                                placeholder="请选择税收居民国家/地区"
                            >
                                <el-option
                                    v-for="item in speCountrys"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                >
                                    <span style="float: left">{{ item.subitemname }}</span>
                                    <span
                                        style="
                                            float: right;
                                            color: var(--color-text-accent);
                                            font-size: 12px;
                                        "
                                    >
                                        {{ item.subitem }}
                                    </span>
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="有无纳税人识别号：" prop="tHaveTaxID" class="required">
                            <el-select
                                v-model="taxesInfo.tHaveTaxID"
                                :disabled="isJustCheck"
                                filterable
                                placeholder="请选择有无居民国家/地区纳税人识别号"
                            >
                                <el-option
                                    v-for="item in tHaveTaxIDs"
                                    :key="item.val"
                                    :label="item.text"
                                    :value="item.val"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.tHaveTaxID === '1'"
                            label="纳税人识别号："
                            prop="taxesno"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.taxesno"
                                placeholder="请输入居民国家/地区纳税人识别号"
                                :maxlength="100"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="taxesInfo.tHaveTaxID === '0'"
                            label="不能提供的原因："
                            prop="notaxesreason"
                            class="required"
                        >
                            <el-select
                                v-model="taxesInfo.notaxesreason"
                                :disabled="isJustCheck"
                                filterable
                                placeholder="请选择不能提供识别号的原因"
                            >
                                <el-option
                                    v-for="item in notaxesreasons"
                                    :key="item.subitem"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            v-if="
                                taxesInfo.tHaveTaxID === '0' &&
                                taxesInfo.notaxesreason == '2' &&
                                taxesInfo.nogetreason !== '0'
                            "
                            label="未能取得的原因："
                            prop="nogetreason"
                            class="required"
                        >
                            <el-input
                                v-model="taxesInfo.nogetreason"
                                placeholder="请输入未能取得纳税人识别号的原因"
                                :maxlength="128"
                                :disabled="isJustCheck"
                            />
                        </el-form-item>
                    </el-col>
                </el-col>
                <el-col v-if="isPwdCheck" :span="12">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model="taxesInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                            :disabled="isJustCheck"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="!isJustCheck" :span="24">
                    <el-form-item label="本人保证：" prop="agreement">
                        <el-checkbox-group v-model="taxesInfo.protocol" class="checkbox-list">
                            <el-checkbox label="1" name="agree">
                                本人确认上述信息的真实、准确、完整性，且当这些信息发生变更时，将及时通知贵机构，否则，本人承担由此造成的不利后果。
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="btn-group">
                    <el-button class="medium back" v-on:click="$router.back()">返回</el-button>
                    <el-button
                        v-if="$util.getConfig().hideFunc"
                        type="primary"
                        class="medium save"
                        v-on:click="submitInfo('taxesInfo')"
                    >
                        保存
                    </el-button>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
import userApi from "@/api/user";
const debounce = (function () {
    let timer = 0;
    return function (callback, ms = 200) {
        // 设置默认200ms
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();
export default {
    name: "CrsInfo",
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            taxesInfo: {
                investorsbirthday: "",
                taxestype: "",
                custfamilyname: "",
                custfirstname: "",
                currentcountry: "",
                currentprovince: "",
                currentcity: "",
                county: "",
                address: "",
                crspostcode: "",
                engcurrentcountry: "",
                engcurrentprovince: "",
                engcurrentcity: "",
                engaddress: "",
                birthcountry: "",
                birthprovince: "",
                birthcity: "",
                birthplace: "",
                engbirthcountry: "",
                engbirthprovince: "",
                engbirthcity: "",
                engbirthplace: "",
                regregioncode: "",
                regadress: "",
                taxesplace: "",
                tHaveTaxID: "",
                taxesno: "",
                notaxesreason: "",
                nogetreason: "",
                protocol: [],
                agreement: "",
                pwd: ""
            },
            isPwdCheck: false,
            taxId: "", // 传入修改税收居民信息ID
            lock: "", // 是否是没有税收居民信息新增
            taxe: false, // 是否是中国税收居民
            isChina: false, // 是否是居住地在中国
            oldTax: "", // 原税收军民信息
            taxestypes: [],
            speCountrys: [], // 税收居民国家/地区数据字典
            originSpeCountrys: [], // 原始税收居民国家数据，用于搜索过滤
            countrys: [],
            originCountrys: [], // 原始国家数据，用于搜索过滤
            enCountrys: [],
            originEnCountrys: [], // 原始英文国家数据，用于搜索过滤
            provinces: [],
            currentcity: [],
            birthcity: [],
            county: [],
            notaxesreasons: [],
            tHaveTaxIDs: [
                { val: "0", text: "无" },
                { val: "1", text: "有" }
            ],
            taxestypeOld: "",
            nonMandatory: false,
            rules: {
                taxestype: [{ required: true, message: "请选择税收居民身份", trigger: "change" }],
                custfirstname: [
                    { required: true, message: "请输入姓", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                custfamilyname: [
                    { required: true, message: "请输入名", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engcurrentprovince: [
                    { required: true, message: "请输入现居省份", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engcurrentcity: [
                    { required: true, message: "请输入现居城市", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engaddress: [
                    { required: true, message: "请输入现居地址", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthprovince: [
                    { required: true, message: "请输入出生省份", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthcity: [
                    { required: true, message: "请输入出生城市", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                engbirthplace: [
                    { required: true, message: "请输入出生地址", trigger: "blur" },
                    { validator: this.$util.validateChar, trigger: "blur" }
                ],
                address: [
                    { required: true, message: "请输入现居地地址", trigger: "blur" },
                    { validator: this.validateAddress, trigger: "blur" }
                ],
                // crspostcode: [
                //     { required: true, message: "请输入现居地邮编", trigger: "blur" },
                //     { validator: this.$util.validatePostCode, trigger: "blur" }
                // ],
                nogetreason: [
                    {
                        required: true,
                        message: "请输入未能取得纳税人识别号的原因",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                taxesno: [
                    { required: true, message: "请输入居民国家/地区纳税人识别号", trigger: "blur" },
                    { validator: this.$util.validateCCharacter, trigger: "blur" }
                ],
                currentcountry: [
                    { required: true, message: "请选择现居地国家/地区", trigger: "change" }
                ],
                currentprovince: [
                    { required: true, message: "请选择现居地省份", trigger: "change" }
                ],
                agreement: [
                    {
                        required: true,
                        message: "请确认上述信息的真实、准确和完整",
                        trigger: "change"
                    }
                ],
                currentcity: [{ required: true, message: "请选择现居地城市", trigger: "change" }],
                county: [{ required: true, message: "请选择现居地县", trigger: "change" }],
                engcurrentcountry: [
                    { required: true, message: "请选择现居地国家(英文或拼音)", trigger: "change" }
                ],
                birthcountry: [
                    { required: true, message: "请选择出生地国家/地区", trigger: "change" }
                ],
                birthprovince: [{ required: true, message: "请选择出生地省份", trigger: "change" }],
                birthcity: [{ required: true, message: "请选择出生地城市", trigger: "change" }],
                engbirthcountry: [
                    {
                        required: true,
                        message: "请选择出生地国家/地区(英文或拼音)",
                        trigger: "change"
                    }
                ],
                taxesplace: [
                    { required: true, message: "请选择税收居民国家/地区", trigger: "change" }
                ],
                tHaveTaxID: [
                    {
                        required: true,
                        message: "请选择有无居民国家/地区纳税人识别号",
                        trigger: "change"
                    }
                ],
                notaxesreason: [
                    { required: true, message: "请选择不能提供识别号的原因", trigger: "change" }
                ],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            },
            showdata: false,
            isJustCheck: false
        };
    },
    watch: {
        "taxesInfo.taxestype"(val) {
            // 税收居民类型 0.仅为中国税收居民  1.仅为非居民  2.同为中国及其它国税收居民 3 不配合客户
            // 中国税收居民 企业税收类型不能选 非居民消极非金融机构
            let taxesflags = (this.taxesflags = this.$cache.getDict("120042"));
            if (val === "0") {
                this.taxesflags = taxesflags && taxesflags.filter((item) => item.subitem !== "2");
            }
            // 仅为非居民 企业税收类型不能选 居民消极非金融机构
            if (val === "1") {
                this.taxesflags = taxesflags && taxesflags.filter((item) => item.subitem !== "1");
            }
            if (val !== "1" && val !== "2") {
                this.taxe = false;
            } else {
                /* if (this.taxesInfo.taxesplace === "CN") {
                    this.taxesInfo.taxesplace = "";
                } */
                this.taxe = true;
            }
        },
        "taxesInfo.currentcity"(val) {
            if (val !== "") {
                this.getCounty(val);
            }
        },
        "taxesInfo.tHaveTaxID"(val) {
            if (val === "0") {
                this.taxesInfo.taxesno = "";
            } else {
                this.taxesInfo.notaxesreason = "";
                this.taxesInfo.nogetreason = "";
            }
        },
        "taxesInfo.currentcountry"(val) {
            if (val !== "CN") {
                this.isChina = false;
            } else {
                this.isChina = true;
            }
        },
        "taxesInfo.protocol"(val) {
            if (val.length > 0) {
                this.taxesInfo.agreement = val.join(",");
            } else {
                this.taxesInfo.agreement = "";
            }
        },
        "taxesInfo.notaxesreason"(val) {
            if (val !== "2") {
                this.taxesInfo.nogetreason = "";
            }
        }
    },
    created() {
        // 初始化数据字典值
        this.isPwdCheck = this.$cache.getPwdCheck("T3,T4");
        const info = this.$cache.getUser();
        this.taxesInfo.investorsbirthday = info.birthday;
        this.taxId = this.$route.query.taxid;
        this.lock = this.$route.query.lock || "";
        this.oldTax = this.$route.query.tax || "";
        this.isJustCheck = !this.$util.getConfig().hideFunc;
        if (this.taxId) {
            this.getTaxesInfo(this.taxId);
        } else {
            this.showdata = true;
        }
        this.taxestypes = this.$cache.getDict("120043");
        this.taxesflags = this.$cache.getDict("120042");
        this.taxestypes = this.taxestypes.filter((item) => item.subitem !== "3");
        if (this.lock) {
            this.$set(this.taxesInfo, "taxestype", this.oldTax);
            /* this.taxestypes = this.taxestypes.filter(item => {
                return item.subitem !== "1";
            }); */
        } else {
            this.$set(this.taxesInfo, "taxestype", "0");
        }
        // this.countrys = this.$cache.getDict("120109");
        this.countrys = this.$util.sortCountryWithChinaFirst(this.$cache.getDict("120109"));
        // 保存原始数据用于搜索
        this.originCountrys = [...this.countrys];
        this.speCountrys = this.countrys.filter((item) => {
            return item.subitem !== "CN";
        });
        // 保存原始税收居民国家数据用于搜索
        this.originSpeCountrys = [...this.speCountrys];
        this.enCountrys = this.$cache.getDict("120109");
        // 按国家码 subitem 排序
        this.enCountrys.sort((a, b) => {
            if (a.subitem < b.subitem) return -1;
            if (a.subitem > b.subitem) return 1;
            return 0;
        });
        // 保存原始英文国家数据用于搜索
        this.originEnCountrys = [...this.enCountrys];
        this.provinces = this.$cache.getDict("190021");
        this.notaxesreasons = this.$cache.getDict("120044");
    },
    methods: {
        // 根据国家名称和国家码搜索过滤（中文）
        filterCountrys(query) {
            if (query) {
                this.countrys = this.originCountrys.filter((item) => {
                    const name = item.subitemname && item.subitemname.toLowerCase();
                    const code = item.subitem && item.subitem.toLowerCase();
                    const searchQuery = query.toLowerCase();
                    return name && name.includes(searchQuery) || code && code.includes(searchQuery);
                });
            } else {
                this.countrys = [...this.originCountrys];
            }
        },
        // 根据国家名称和国家码搜索过滤（英文）
        filterEnCountrys(query) {
            if (query) {
                this.enCountrys = this.originEnCountrys.filter((item) => {
                    const name = item.subitemname && item.subitemname.toLowerCase();
                    const code = item.subitem && item.subitem.toLowerCase();
                    const searchQuery = query.toLowerCase();
                    return name && name.includes(searchQuery) || code && code.includes(searchQuery);
                });
            } else {
                this.enCountrys = [...this.originEnCountrys];
            }
        },
        // 根据国家名称和国家码搜索过滤（税收居民国）
        filterSpeCountrys(query) {
            if (query) {
                this.speCountrys = this.originSpeCountrys.filter((item) => {
                    const name = item.subitemname && item.subitemname.toLowerCase();
                    const code = item.subitem && item.subitem.toLowerCase();
                    const searchQuery = query.toLowerCase();
                    return name && name.includes(searchQuery) || code && code.includes(searchQuery);
                });
            } else {
                this.speCountrys = [...this.originSpeCountrys];
            }
        },
        validateAddress(rule, value, callback) {
            if (this.isChina || value.trim() !== "") {
                this.$util.validateCCharacter(rule, value, callback);
            } else {
                callback();
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            debounce(async () => {
                const _this = this;
                _this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        const way =
                            _this.lock || _this.taxId === "0" || _this.fn || !_this.taxId
                                ? "POST"
                                : "PUT";
                        // 判断是否重复修改中国税收居民身份
                        if (_this.taxestypeOld === "0" && _this.taxesInfo.taxestype === "0") {
                            _this.$message({
                                type: "warning",
                                message: "投资者已为中国税收居民，无需修改！"
                            });
                            return false;
                        }
                        if (_this.taxesInfo.taxestype === "0") {
                            _this.taxesInfo.taxesplace = "CN";
                        }
                        const _x = Object.assign({}, _this.taxesInfo);
                        delete _x.protocol;
                        // _x.tradepwd = _this.$util.enc(_x.pwd);
                        delete _x.pwd;
                        if (!this.$route.query.type) {
                            const updReq = await userApi.updAcctCrsInfoHandler(_x);
                            if (updReq.code === "0") {
                                this.$message({
                                    type: "success",
                                    message: "修改成功！"
                                });
                            }
                        } else {
                            const addReq = await userApi.addAcctCrsInfoHandler(_x);
                            if (addReq.code === "0") {
                                this.$message({
                                    type: "success",
                                    message: "新增成功！"
                                });
                            }
                        }
                        setTimeout(() => {
                            this.$router.push({ name: `taxeslist` });
                        }, 500);
                    } else {
                        this.$errorScroll();
                    }
                });
            }, 200);
        },
        async getTaxesInfo(id) {
            const _this = this;
            const res = await userApi.qryAcctCrsInfoService({ taxiesinfoid: id });
            _this.taxesInfo = Object.assign({}, _this.taxesInfo, res.data[0] || {});
            this.getCity(this.taxesInfo.birthprovince, "birthcity");
            setTimeout(() => {
                this.getCity(this.taxesInfo.currentprovince, "currentcity");
            }, 1000);
            if (this.taxesInfo.notaxesreason === "0" || this.taxesInfo.notaxesreason === "1") {
                this.taxesInfo.notaxesreason = "1";
            } else {
                this.taxesInfo.notaxesreason = "2";
            }
            if (_this.taxesInfo.taxesno) {
                _this.taxesInfo.tHaveTaxID = "1";
            } else {
                _this.taxesInfo.tHaveTaxID = "0";
            }
            _this.taxestypeOld = _this.taxesInfo.taxestype;
            _this.showdata = true;
        },
        async getCity(val, citykey) {
            let cityList = this.$cache.get("address")["citylists"][val] || [];
            this[citykey] = cityList;
        },
        getCounty(val) {
            let countyList = this.$cache.get("address")["countylists"][val] || [];
            this.county = countyList;
        },
        currentcountrySel() {
            this.taxesInfo.currentprovince = "";
            this.taxesInfo.currentcity = "";
            this.taxesInfo.county = "";
        },
        currentprovinceSel() {
            this.taxesInfo.currentcity = "";
            this.taxesInfo.county = "";
            if (!this.taxesInfo.currentprovince) return;
            // this.getCityList(this.taxesInfo.currentprovince, "currentcity")
            this.getCity(this.taxesInfo.currentprovince, "currentcity");
        },
        currentcitySel(val) {
            let countyList = this.$cache.get("address")["countylists"][val] || [];
            this.county = countyList;
        }
    }
};
</script>
<style lang="scss">
.comp-crs-info {
    .taxes-box {
        padding: 30px 20px 40px;
        .mes-col {
            margin-bottom: 10px;
            &.last {
                margin-bottom: 0;
            }
            .cut-off-line {
                margin: 30px 0 0;
                top: -30px;
                font-size: $f16;
            }
            .el-form-item__label {
                font-size: 14px;
                color: #333333;
            }
            .el-form-item__content {
                font-size: 16px;
                color: #1a1a1a;
            }
        }
        .el-checkbox__inner {
            border-radius: 50%;
        }
        .el-checkbox__label {
            font-size: 16px;
            color: #999999;
        }
    }
    .btn-group {
        margin-top: 40px;
        .back {
            color: #666666;
            background: #e4e4e4;
        }
        .save {
            color: #ffffff;
            background: var(--color-primary);
        }
    }
}
.line-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
</style>
